import React, { useEffect, useState } from "react";
import {
  CircularProgress,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormLabel,
  MenuItem,
  Select,
} from "@mui/material";
import GridItem from "../../../components/Grid/GridItem";
import TranslationWrapper, { getTranslation } from "../../../components/TranslationWrapper/TranslationWrapper";
import GridContainer from "../../../components/Grid/GridContainer";
import SaveButton from "../../../components/CustomInput/SaveButton";
import { useDialog } from "../../../licensing/utils/DialogProvider";
import ControlledInput from "../../../components/CustomInput/ControlledInput";
import SubsSubscriptionAdditional, {
  OrderStatus,
  StatusInvoicing,
  Type,
} from "../../../licensing/Models/SubsSubscriptionAdditional";
import * as actions from "../../../store/actions";
import { connect } from "react-redux";
import { toast } from "react-toastify";
import AsynchronousAutocomplete from "../../../components/Autocomplete/AsynchronousAutocomplete";
import { format } from "date-fns";

function EditAdditionalInvoiceLine(props) {
  const [originalSubsSubscriptionAdditional, setOriginalSubsSubscriptionAdditional] = useState(null);
  const [saving, setSaving] = useState(false);
  const [hasError, setHasError] = useState(false);
  const [subscription, setSubscription] = useState(null);
  const [subsSubscriptionAdditional, setSubsSubscriptionAdditional] = useState(null);
  const [, closeDialog] = useDialog();

  useEffect(() => {
    // eslint-disable-next-line react/prop-types
    SubsSubscriptionAdditional.get(props.SubsSubscriptionAdditionalLineId).then(({ model }) => {
      setSubsSubscriptionAdditional(model);
      setOriginalSubsSubscriptionAdditional(Object.assign(Object.create(model), model));
    });
  }, []);

  return (
    <>
      <DialogTitle>Edit additional item to be invoiced</DialogTitle>
      <DialogContent style={{ minHeight: 400 }}>
        {subsSubscriptionAdditional == null ? <CircularProgress /> : null}
        {subsSubscriptionAdditional != null ? (
          <GridContainer>
            <GridItem sm={4} xs={12}>
              <FormLabel>
                <TranslationWrapper tKey={"Type"} />
              </FormLabel>
            </GridItem>
            <GridItem sm={8} xs={12}>
              <Select
                onChange={(e) => {
                  subsSubscriptionAdditional.type = e.target.value;
                  setSubsSubscriptionAdditional(
                    Object.assign(Object.create(subsSubscriptionAdditional), subsSubscriptionAdditional)
                  );
                }}
                style={{ width: "100%" }}
                value={subsSubscriptionAdditional.type}
              >
                {Object.keys(Type).map((type) => {
                  return <MenuItem value={type}>{type}</MenuItem>;
                })}
              </Select>
            </GridItem>
            <GridItem sm={4} xs={12}>
              <FormLabel>
                <TranslationWrapper tKey={"Orderstatus"} />
              </FormLabel>
            </GridItem>
            <GridItem sm={8} xs={12}>
              <Select
                onChange={(e) => {
                  subsSubscriptionAdditional.order_status = e.target.value;
                  setSubsSubscriptionAdditional(
                    Object.assign(Object.create(subsSubscriptionAdditional), subsSubscriptionAdditional)
                  );
                }}
                style={{ width: "100%" }}
                value={subsSubscriptionAdditional.order_status}
              >
                {Object.keys(OrderStatus).map((order_status) => {
                  return <MenuItem value={order_status}>{order_status}</MenuItem>;
                })}
              </Select>
            </GridItem>
            <GridItem sm={4} xs={12}>
              <FormLabel>
                <TranslationWrapper tKey={"Active on salesareas"} />
              </FormLabel>
            </GridItem>
            <GridItem sm={8} xs={12}>
              <AsynchronousAutocomplete
                async={{
                  url: `core/vestigingen/search?fields=id,id as value,naam as label&sort_field=naam&sort_dir=asc`,
                  searchField: "naam",
                  perPage: 20,
                }}
                key={"selectSalesAreas"}
                multiple={true}
                onChange={(e, option) => {
                  let vList = [];
                  if (option && option.length > 0) {
                    /**
                     * Vol
                     */
                    option.forEach((item) => {
                      vList.push(item.value);
                    });
                  } else {
                    /**
                     * Leeg
                     */
                    vList = [];
                  }
                  subsSubscriptionAdditional.salesarea_ids = vList;
                  setSubsSubscriptionAdditional(
                    Object.assign(Object.create(subsSubscriptionAdditional), subsSubscriptionAdditional)
                  );
                }}
                placeholder={getTranslation("Search salesareas")}
                value={subsSubscriptionAdditional.salesarea_ids.map((vid) => {
                  return { value: vid };
                })}
              />
            </GridItem>
            <GridItem sm={4} xs={12}>
              <FormLabel>
                <TranslationWrapper tKey={"Invoiceing status"} />
              </FormLabel>
            </GridItem>
            <GridItem sm={8} xs={12}>
              <Select
                onChange={(e) => {
                  subsSubscriptionAdditional.status_invoicing = e.target.value;
                  setSubsSubscriptionAdditional(
                    Object.assign(Object.create(subsSubscriptionAdditional), subsSubscriptionAdditional)
                  );
                }}
                style={{ width: "100%" }}
                value={subsSubscriptionAdditional.status_invoicing}
              >
                {Object.keys(StatusInvoicing).map((status_invoicing) => {
                  return <MenuItem value={status_invoicing}>{status_invoicing}</MenuItem>;
                })}
              </Select>
            </GridItem>
            <GridItem sm={4} xs={12}>
              <FormLabel>
                <TranslationWrapper tKey={"Start date"} />
              </FormLabel>
            </GridItem>
            <GridItem sm={8} xs={12}>
              <ControlledInput
                onHandleValue={(value) => {
                  subsSubscriptionAdditional.start_date = value;
                  setSubsSubscriptionAdditional(
                    Object.assign(Object.create(subsSubscriptionAdditional), subsSubscriptionAdditional)
                  );
                }}
                style={{ width: "100%" }}
                type={"date"}
                value={format(subsSubscriptionAdditional.start_date, "yyyy-MM-dd")}
              />
            </GridItem>
            <>
              <GridItem sm={4} xs={12}>
                <FormLabel>
                  <TranslationWrapper tKey={"Unit price"} />
                </FormLabel>
              </GridItem>
              <GridItem sm={8} xs={12}>
                <ControlledInput
                  onHandleValue={(value) => {
                    subsSubscriptionAdditional.unit_price = value;
                    setSubsSubscriptionAdditional(
                      Object.assign(Object.create(subsSubscriptionAdditional), subsSubscriptionAdditional)
                    );
                  }}
                  style={{ width: "100%" }}
                  type={"currency"}
                  value={subsSubscriptionAdditional.unit_price}
                />
              </GridItem>
            </>
            <GridItem sm={4} xs={12}>
              <FormLabel>
                <TranslationWrapper tKey={"Notes"} />
              </FormLabel>
            </GridItem>
            <GridItem sm={8} xs={12}>
              <ControlledInput
                onHandleValue={(value) => {
                  subsSubscriptionAdditional.notes = value;
                  setSubsSubscriptionAdditional(
                    Object.assign(Object.create(subsSubscriptionAdditional), subsSubscriptionAdditional)
                  );
                }}
                style={{ width: "100%" }}
                type={"text"}
                value={subsSubscriptionAdditional.notes}
              />
            </GridItem>
          </GridContainer>
        ) : null}
      </DialogContent>
      <DialogActions style={{ justifyContent: "center" }}>
        <SaveButton
          onClick={() => {
            setSaving(true);
            let newValues = {};
            Object.keys(originalSubsSubscriptionAdditional).forEach((attribute) => {
              if (originalSubsSubscriptionAdditional[attribute] !== subsSubscriptionAdditional[attribute]) {
                newValues[attribute] = subsSubscriptionAdditional[attribute];
              }
            });
            subsSubscriptionAdditional
              .apiUpdate(newValues)
              .then(() => {
                props.onSaved();
                closeDialog();
              })
              .catch(() => {
                setSaving(false);
                toast.error("Error");
              });
          }}
        />
      </DialogActions>
    </>
  );
}

const mapDispatchToProps = (dispatch) => {
  return {
    showMessage: (message) => dispatch({ type: actions.SHOW_MESSAGE, message: message }),
  };
};

export default connect(null, mapDispatchToProps)(EditAdditionalInvoiceLine);
